<h2 mat-dialog-title>Anexar Laudo</h2>

<mat-dialog-content>
    <section class="readonly">
        <div><strong>ID da Indicação:</strong> {{ data.row?.id }}</div>
        <div><strong>Status:</strong> {{ data.row?.status }}</div>
        <div><strong>Nome do Paciente:</strong> {{ data.row?.patient?.name }}</div>
        <div><strong>CPF do Paciente:</strong> {{ data.row?.patient?.cpf }}</div>
    </section>

    <mat-accordion *ngIf="schedules.length">
        <mat-expansion-panel *ngFor="let s of schedules; trackBy: trackBySchedule">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span class="schedule-date">{{ s.date | date:'DD/MM/YYYY HH:mm' }}</span>
                    <span class="doctor-name">{{ s.doctorName }}</span>
                </mat-panel-title>
                <mat-panel-description class="status-description">
                    <span app-badge [color]="statusBadgeColor(s.status)" appearance="tonal" size="sm">{{ s.status }}</span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <app-schedule-report-panel
                [schedule]="s"
                [indicationId]="data.row.id"
                (attached)="onAttached()">
            </app-schedule-report-panel>
        </mat-expansion-panel>
    </mat-accordion>

    <p *ngIf="loadingSchedules && !schedules.length">Carregando consultas...</p>
    <p *ngIf="!loadingSchedules && !schedules.length">Nenhuma consulta encontrada para esta indicação.</p>

    <div class="actions modal-actions">
        <button app-button type="button" appearance="tonal" color="danger" (click)="close()">Fechar</button>
    </div>
</mat-dialog-content>
